import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import Button from 'components/Button';
import { Text } from 'components/ui';
import OutOfStockButton from 'components/AddToBasketButton/OutOfStockButton/OutOfStockButton';
import basketConstants from 'constants/Basket';
import skuUtils from 'utils/Sku';
import {
    buttons, fontSizes, mediaQueries, space
} from 'style/config';

function ActionButton({
    sku, isOutOfStock, isMoving, onClick, getText
}) {
    const { BasketType } = basketConstants;

    if (skuUtils.isCountryRestricted(sku)) {
        return (
            <Text
                is='p'
                color='gray'
                css={styles.restrictedText}
            >
                {getText('itemShip')}
            </Text>
        );
    }

    if (isOutOfStock) {
        return (
            <OutOfStockButton
                basketType={BasketType.Standard}
                variant='secondary'
                size='sm'
                sku={sku}
                customStyle={styles.outOfStockButton}
            />
        );
    }

    return (
        <Button
            variant='secondary'
            size='sm'
            onClick={onClick}
            css={styles.button}
            disabled={isMoving}
        >
            {isMoving ? getText('moved') : getText('moveToBasket')}
        </Button>
    );
}

const styles = {
    restrictedText: {
        width: '142px',
        padding: `0 ${space[4]}px`
    },
    button: {
        width: '142px',
        height: `${buttons.HEIGHT}px`,
        minHeight: `${buttons.HEIGHT}px`,
        fontSize: `${fontSizes.base}px`,
        padding: `13px ${space[4]}px`,
        [mediaQueries.xsMax]: {
            width: '133px',
            minHeight: `${buttons.HEIGHT_SM}px`,
            fontSize: `${fontSizes.sm}px`,
            padding: `9px ${space[3]}px`
        }
    },
    outOfStockButton: {
        width: '142px',
        minHeight: `${buttons.HEIGHT}px`,
        fontSize: `${fontSizes.sm}px`,
        padding: `13px ${space[4]}px`,
        [mediaQueries.xsMax]: {
            width: '133px',
            height: `${buttons.HEIGHT_SM}px`,
            fontSize: `${fontSizes.xs}px`,
            padding: `9px ${space[3]}px`
        }
    }
};

ActionButton.propTypes = {
    sku: PropTypes.object.isRequired,
    isOutOfStock: PropTypes.bool.isRequired,
    isMoving: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(ActionButton, 'ActionButton');
